import { Box, Link, Stack, Tooltip, Typography } from '@mui/material';

import { appConfig } from '@/config/app.config';
import { monoFontFamily } from '@/theme/theme';

export function Footer() {
  const { version, builtAt } = appConfig.build;

  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, md: 3.25 },
        py: 1.25,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 0.5, sm: 2 }}
        alignItems={{ sm: 'center' }}
      >
        <Tooltip title={`Built ${builtAt}`}>
          <Typography variant="caption" color="text.disabled">
            {appConfig.name}{' '}
            <Box component="span" sx={{ fontFamily: monoFontFamily, fontWeight: 600 }}>
              v{version}
            </Box>
          </Typography>
        </Tooltip>

        <Box sx={{ flex: 1 }} />

        <Link
          href="mailto:support@otrack.ai"
          variant="caption"
          color="text.secondary"
          underline="hover"
        >
          Support
        </Link>
      </Stack>
    </Box>
  );
}
